import { UserOffice } from "@/type/core/auth/auth.types";
import { createEvent } from "effector";

export const setSelectedOfficeForModelMail = createEvent<
  UserOffice | undefined
>("SET_SELECTED_OFFICE");
